import React, { useEffect, useState } from "react";
import { useOperador } from "../../context/OperadorContext";
import { useDividas } from "../../context/DividasContext";
import { useAuth } from "../../context/AuthContext";
import { useCookies } from "react-cookie";
import Swal from "sweetalert2";
import { ConsultaDebitoResponse } from "../../types/divida-interface";
import { isValidCNPJ, isValidCPF } from "@brazilian-utils/brazilian-utils";
import { SelectTipo } from "../../components/OperadorCaixa/components/select-tipo";
import { ResponsiveModal } from "../../components/ResponsiveModal";
import { Spinner } from "../../components/Spinner";
// import { OptionBtn } from "../Operador/option-btn";
// import ReactInputMask from "react-input-mask";
import FilaCobranca from "../../components/OperadorCaixa/components/fila-cobranca";
import { AtendimentoForms } from "../../components/Atendimento/atendimento-forms";
import { DiscadorProvider } from "../../components/Discador";
import { SwitchButtonLogin } from "../../components/Hibrido/switch-button-login";
import { aplicarMascara } from "../../utils/mascaraTelefone";
import { SelectBreak } from "../../components/Pausas/components/select-breaks";
import { PhoneOffButton } from "../../components/Hibrido/phone-off-button";
import { PauseTimeProvider } from "../../hooks/usePauseTime";
import { GenericModal } from "../../components/Modal";
import { PauseTime } from "../../components/Pausas/components/pause-time";
import { useModal } from "../../hooks/ModalContext";
import { useHibrido } from "../../context/HibridoContext";
import { Chat } from '../../components/OperadorCaixa/components/chat'
import { TipoDiscagemModal } from '../../components/Modal/components/tipo-discagem'
import { useOperadorCaixa } from "../../context/OperadorCaixaContext";
import { formatCPFCNPJ } from "../../utils/formatCPFCNPJ";

interface UsuarioDiscador {
  urlDiscador: string;
  usuarioDiscador: string;
  senhaDiscador: string;
  token3C: string
}


export function OperadorCaixa() {
  const [tipoDiscagem, setTipoDiscagem] = useState<string>('Manual')
  const [usuarioDiscador, setUsuarioDiscador] = useState<UsuarioDiscador | null>(null);
  const [aberto, setAberto] = useState<boolean>(false);
  const [isCpfSearch, setIsCpfSearch] = useState(true);
  const { tab, setTab } = useOperador();
  const { setDevedor, devedor, clearDividas } = useDividas();
  // const [isChatOpen, setIsChatOpen] = useState(false);
  const { validToken, cookies, decodedToken } = useAuth();
  const [, setCookies] = useCookies(["token", "user"]);
  const { dadosChamada } = useHibrido();
  const { modalInfo, onClose, setModal } = useModal();
  const [showModal, setShowModal] = useState(false);
  const openModal = () => setShowModal(true);
  const closeModal = () => {
    setShowModal(false);
    setCpfValue("");
    setIsCpfInvalid(false)
  };
  const { getDividasGazin } = useDividas();
  const [isCpfInvalid, setIsCpfInvalid] = useState<null | boolean>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [cpfValue, setCpfValue] = useState("");
  const { data } = useOperadorCaixa();


  const findByCpf: React.FormEventHandler<HTMLFormElement> = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    // const values = e.target as typeof e.target & {
    //   cpf: { value: string };
    // };
    // const { cpf } = values;
    const numbers = cpfValue.replace(/\D/g, "");
    if (numbers.length === 11) {
      if (!isValidCPF(numbers)) {
        setIsCpfInvalid(true);
        setIsLoading(false);
        return;
      }
    } else {
      if (!isValidCNPJ(numbers)) {
        setIsCpfInvalid(true);
        setIsLoading(false);
        return;
      }
    }


    setCpfValue('')
    try {
      const find = data?.data?.find(item => formatCPFCNPJ(item.cpf_cnpj) === formatCPFCNPJ(numbers))
      if (find) {
        clearDividas()
        await getDividasGazin({ cpf_cnpj: numbers, id: Number(numbers), app: 'ACIONA_CXA' });
        handleOpenTab("atendimento");
      } else {
        Swal.fire({
          title: "Ops!",
          text: "O CPF/CNPJ pesquisado não consta na lista da filial.",
          confirmButtonColor: "#103680",
        });
      }

    } catch (err) {
      Swal.fire({
        title: "Ops!",
        text: "Contrato não localizado!",
        confirmButtonColor: "#103680",
      });
    } finally {
      setIsLoading(false);
      closeModal();
      setCpfValue("");
      //@ts-ignore
    }
  };

  function handleButton() {
    if (tipoDiscagem === 'Manual') {
      handleOpenTab('fila-cobranca')
    } else {
      handleOpenTab('atendimento')
    }
    setAberto(true)
  }

  useEffect(() => {
    validToken(cookies?.token);
    if (!cookies?.user) {
      const decoded = decodedToken();
      setCookies("user", {
        id_operador: decoded.id_usuario,
        nome: decoded.nome,
      });
    }
    setDevedor({} as ConsultaDebitoResponse);
  }, []);

  function handleOpenTab(tab: string) {
    setTab(tab);
  }


  useEffect(() => {

    const decoded = decodedToken();

    if (decoded.urlDiscador || decoded.token3C) {
      setUsuarioDiscador({
        urlDiscador: decoded?.urlDiscador,
        usuarioDiscador: decoded?.usuarioDiscador,
        senhaDiscador: decoded?.senhaDiscador,
        token3C: decoded.token3C
      });
      // console.log(decoded)
    }


  }, [decodedToken]);

  function maskCPFCNPJ(value: string) {
    const val = value.trim()
    if (val.length >= 15) {
      return val
        .replace(/\D/g, '')
        .replace(/^(\d{2})(\d)/, '$1.$2')
        .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
        .replace(/\.(\d{3})(\d)/, '.$1/$2')
        .replace(/(\d{4})(\d)/, '$1-$2');
    } else {
      return val
        .replace(/\D/g, '')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})/, '$1-$2')
        .replace(/(-\d{2})\d+?$/, '$1');
    }
  }




  return (
    <>
      <DiscadorProvider socketUrl={usuarioDiscador?.urlDiscador || ''}
        user={''}
        password={''} >


        <section>

          <div className={` m-4 mt-10 flex max-h-max  flex-grow flex-col overflow-y-auto  ${tab === "fila-cobranca" ? "w-[121%]" : ""}`}>
            {!aberto && <div className=" h-chatBar w-[80%] flex items-center justify-center ">

              <SelectTipo tipoDiscagem={tipoDiscagem} setTipoDiscagem={setTipoDiscagem} handleButton={handleButton} isCaixa />

            </div>}

            <div>
              {
                aberto && (
                  <>
                    <div className="flex items-center gap-4 mb-0.5">

                      <button
                        className={`aba-operador  ${tab === "fila-cobranca" ? " bg-slate-300" : " bg-slate-200"
                          } ${tipoDiscagem !== 'Manual' && 'hidden'}
              `}
                        onClick={() => handleOpenTab("fila-cobranca")}
                      >
                        Fila de cobrança
                      </button>

                      <button
                        className={`aba-operador ${tab === "atendimento" ? " bg-slate-300" : " bg-slate-200"
                          } ${!devedor.name && "cursor-not-allowed"}
              `}
                        disabled={!devedor.name ? true : false}
                        onClick={() => handleOpenTab("atendimento")}
                      >
                        Atendimento
                      </button>

                      <button
                        className={`aba-operador cursor-pointer bg-slate-200 `}
                        onClick={openModal}
                      >
                        Consulta por CPF
                      </button>

                      <button
                        className={`aba-operador  bg-slate-200`}
                        // disabled={!devedor.name ? true : false}
                        onClick={() => { setModal('Tipo Discagem', 'Tipo Discagem') }}
                      >
                        Tipo Discagem
                      </button>


                      <SwitchButtonLogin />

                      <div className="flex items-center gap-2 text-sm">
                        <strong className="font-normal text-primary">Telefone Bina: </strong>
                        <p className="">
                          {aplicarMascara(dadosChamada?.call?.phone?.replace('55', ''))}
                        </p>
                      </div>
                      <SelectBreak />

                      <PhoneOffButton />
                      <PauseTimeProvider>
                        <PauseTime />
                        <GenericModal
                          title={modalInfo.title}
                          type={modalInfo.type}
                          onClose={() => onClose()}
                          show={modalInfo.isOpen && modalInfo.title === 'Pausas Hibrido'}
                          modalType={'Pausas Hibrido'}
                        />
                      </PauseTimeProvider>


                    </div>

                    <div
                      className={
                        "mb-2 mt-1 flex h-[85vh] w-[80%] items-center justify-center border-2 border-slate-300 gap-2 rounded-lg  bg-slate-300 px-2 py-2 -ml-1.5"
                      }
                    >
                      {tab === "fila-cobranca" && (
                        <FilaCobranca handleOpenTab={handleOpenTab} />
                      )}
                      {tab === "atendimento" && (
                        <>
                          <AtendimentoForms isCaixa />
                          {/* {!isChatOpen && <ChatButton onClick={() => setIsChatOpen(true)} />} */}
                          <div className="relative">
                            <Chat />
                          </div>
                        </>
                      )}


                    </div>
                  </>
                )
              }
            </div>
          </div>

          <GenericModal
            title={modalInfo.title}
            type={tipoDiscagem}
            onClose={() => onClose()}
            show={(modalInfo.isOpen && modalInfo.title === 'Qualificacao Chamada') || (modalInfo.isOpen && modalInfo.title === 'Campanha Discador')}
            modalType="Qualificacao Chamada"
          />
          <TipoDiscagemModal tipoDiscagem={tipoDiscagem} setTipoDiscagem={setTipoDiscagem} handleButton={handleButton} isCaixa />

        </section>
        <>
          <ResponsiveModal
            rounded
            open={showModal}
            onClose={closeModal}
            center
            closeIcon
            closeOnOverlayClick
            closeOnEsc
          >
            <div className="h-full p-6 text-center">
              <h1 className="text-2xl font-medium text-primary">
                Consulta CPF/CNPJ
                {/* {isCpfSearch ? "CPF" : "CNPJ"} */}
              </h1>
              <form
                onSubmit={findByCpf}
                className="flex flex-col items-center p-4"
              >
                <div className="">
                  {/* <ReactInputMask
                    mask={isCpfSearch ? "999.999.999-99" : "99.999.999/9999-99"}
                    autoComplete={"off"}
                    placeholder={
                      isCpfSearch ? "000.000.000-00" : "00.000.000/0000-00"
                    }
                    className={`h-14 w-full rounded-md border text-center text-2xl text-slate-500 outline-none focus:border-4 focus:border-blue-800 ${isCpfInvalid
                      ? "border-red-600 focus:border-red-600"
                      : "focus:border-blue-800"
                      }`}
                    name="cpf"
                    id="cpf"
                    onChange={(e) => {
                      setCpfValue(e.target.value);
                      setIsCpfInvalid(false);
                    }}
                    value={cpfValue}
                  /> */}
                  {isCpfInvalid && (
                    <p className="mb-2 text-right text-red-600">
                      {isCpfSearch ? "CPF" : "CNPJ"} Inválido
                    </p>
                  )}
                </div>
                {/* <div className="flex items-center gap-2 h-5 mt-2">
                  <OptionBtn
                    label="CPF"
                    onClick={() => {
                      setIsCpfSearch(true);
                      setCpfValue("");
                    }}
                    isActive={isCpfSearch}
                  />
                  <OptionBtn
                    label="CNPJ"
                    onClick={() => {
                      setIsCpfSearch(false);
                      setCpfValue("");
                    }}
                    isActive={!isCpfSearch}
                  />
                </div> */}
                <input type={'text'} maxLength={18} value={maskCPFCNPJ(cpfValue)} className={`h-12 w-full rounded-md border text-center text-xl text-gray-800 outline-none focus:border-2 focus:border-primary ${isCpfInvalid
                  ? "border-red-600 focus:border-red-600"
                  : "focus:border-primary"
                  }`}
                  onChange={(e) => setCpfValue(e.target.value)}
                  placeholder={
                    "000.000.000-00"
                  }
                />
                <div className="mt-5 flex w-full gap-2">
                  {isLoading ? (
                    <div className="flex w-full justify-center">
                      <Spinner size="sm" />
                    </div>
                  ) : (
                    <>
                      <button
                        type="submit"
                        className="w-full rounded-md bg-primary p-2 text-base font-semibold text-white"
                      >
                        OK
                      </button>
                      <button
                        onClick={closeModal}
                        type="button"
                        className="w-full rounded-md bg-slate-400 p-2 text-base font-semibold text-white"
                      >
                        Cancelar
                      </button>
                    </>
                  )}
                </div>
              </form>
            </div>
          </ResponsiveModal>
        </>
      </DiscadorProvider>
    </>
  )
}